module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/439.b6a33e10.png";